import { render, staticRenderFns } from "./OrgLevelList.vue?vue&type=template&id=15f152fa&"
import script from "./OrgLevelList.vue?vue&type=script&lang=js&"
export * from "./OrgLevelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports